import React from "react";
import { useParams } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import { Card, CardContent, Typography } from "@material-ui/core";
import EventGroupList from "components/presentation/EventGroupList";
import LabeledValue from "components/presentation/LabeledValue";
import { H2, H3 } from "components/presentation/headers";
import ExternalLink from "components/presentation/ExternalLink";
import { formatLocationPath } from "helpers/location";

const GET_COMPANY = gql`
  query GetCompany($id: ID!) {
    company(id: $id) {
      id
      nameJa
      location
      website
      eventGroups {
        id
        ...EventGroupListEventGroup
      }
    }
  }
  ${EventGroupList.fragments.eventGroup}
`;

export default () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(GET_COMPANY, { variables: { id } });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  const { company } = data;
  const { nameJa, location, website, eventGroups } = company;

  return (
    <div>
      <H2>{nameJa}</H2>
      <H3>基本情報</H3>
      <Card>
        <CardContent>
          <LabeledValue label="所在地">
            <Typography>{formatLocationPath(location)}</Typography>
          </LabeledValue>
          <LabeledValue label="ウェブサイト">
            <Typography>
              <ExternalLink href={website} />
            </Typography>
          </LabeledValue>
        </CardContent>
      </Card>
      <H3>この団体の公演</H3>
      <EventGroupList eventGroups={eventGroups} />
    </div>
  );
};
